"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookImageUrl = exports.IMAGE_VARIANTS = exports.LINK_TYPES = exports.LANGUAGES = void 0;
exports.LANGUAGES = ['en', 'es', 'fr', 'bg', 'pt'];
exports.LINK_TYPES = ['seminar', 'discourse', 'excerpt', 'video', 'other'];
exports.IMAGE_VARIANTS = ['original', 'og', 'square', 'display', 'thumb'];
/** Return a specific image variant URL from a book's images array, or null */
function bookImageUrl(book, variant) {
    var _a, _b;
    return (_b = (_a = book.images.find(function (i) { return i.variant === variant; })) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : null;
}
exports.bookImageUrl = bookImageUrl;
